const AdditionalNotes = ({ size = 16, color = "#303030" }: { size?: number; color?: string }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                width: size,
                height: size,
            }}
        >
            <path
                d="M0.803928 16.3917L0.80381 16.3929C0.781225 16.6192 0.859839 16.8469 1.02075 17.0081C1.16412 17.1518 1.35756 17.2322 1.55681 17.2322L1.55979 17.2322C1.57703 17.2323 1.60723 17.2323 1.63968 17.228L6.12457 16.7518L6.1251 16.7517C6.29806 16.7329 6.45878 16.6571 6.58173 16.5306L16.9779 6.11536C17.274 5.81865 17.274 5.33622 16.9779 5.03951L12.9684 1.02269C12.6721 0.72577 12.1899 0.72577 11.8935 1.02269L1.4964 11.4389C1.37602 11.5595 1.29537 11.7224 1.27942 11.8971L0.803928 16.3917ZM12.5079 8.4492L5.70138 15.2683L2.41396 15.616L2.76115 12.3218L9.56729 5.50315L12.5079 8.4492ZM15.373 5.57884L13.5823 7.37282L10.6417 4.42677L12.4324 2.63279L15.373 5.57884ZM16.379 19.2C16.7976 19.2 17.1386 18.8578 17.1386 18.4394C17.1386 18.0209 16.7976 17.6788 16.379 17.6788H2.17236C1.75378 17.6788 1.41277 18.0209 1.41277 18.4394C1.41277 18.8578 1.75378 19.2 2.17236 19.2H16.379Z"
                fill={color}
                stroke={color}
                strokeWidth="0.4"
            />
        </svg>
    );
};

export default AdditionalNotes;
